import { Component, OnInit } from '@angular/core';
import { EmaService } from '../../_services/ema.service';

@Component({
    selector: 'app-ema',
    templateUrl: './ema.component.html',
    styleUrls: ['./ema.component.css']
})
export class EmaComponent implements OnInit {
    model: any = {};
    currentEMA1: any;
    currentEMA2: any;

    emaDefault1: any = [];
    emaDefault2: any = [];
    isValidateEma: any = true;
    msgErrorEma: any = '';
    constructor(
        private emaService: EmaService
    ) {
    }

    ngOnInit() {
        // this.emaService.get().subscribe(res => {
        //     this.emaDefault1 = res.ema_values;
        //     this.emaDefault2 = res.ema_values;
        //     if (res.current) {
        //         this.currentEMA1 = +res.current.ema_default_1;
        //         this.currentEMA2 = +res.current.ema_default_2;
        //     }
        // });
    }

    save() {
        this.model.ema1 = +$('input[name=ema1]:checked', '.form').attr('ng-reflect-value');
        this.model.ema2 = +$('input[name=ema2]:checked', '.form').attr('ng-reflect-value');
        this.emaService.save(this.model).subscribe(res => {
            if (res.error) {
                this.isValidateEma = false;
                this.msgErrorEma = res.message;
            }
        }, error => {
            this.isValidateEma = false;
            if (error.hasOwnProperty('statusText')) {
                this.msgErrorEma = error.statusText;
            }
        });
    }

    checkBothEMA(event: any) {
        this.currentEMA1 = +$('input[name=ema1]:checked', '.form').attr('ng-reflect-value');
        this.currentEMA2 = +$('input[name=ema2]:checked', '.form').attr('ng-reflect-value');

        this.isValidateEma = true;
        if (this.currentEMA1 == this.currentEMA2) {
            this.isValidateEma = false;
            this.msgErrorEma = "EMA1及びEMA2が同じです。";
        }

        this.checkEmaNotExists();
    }

    checkEmaNotExists() {
        let self = this;

        let objEMA1 = self.emaDefault1.find(function (obj) {
            return obj == self.currentEMA1;
        });
        let objEMA2 = self.emaDefault2.find(function (obj) {
            return obj == self.currentEMA2;
        });

        if (objEMA1 == undefined || objEMA2 == undefined) {
            self.isValidateEma = false;
            self.msgErrorEma = "無効なEMA値";
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/ema/ema.component.ts